export default __webpack_public_path__ + "static/media/downloadbtn2.7ea65df8.png";